import React, { useEffect, useState, useContext } from 'react';
import { api } from '../utils/apiHelper';
import UserContext from '../context/UserContext';
import '../styles/BeatBin.css';

const BeatBin = () => {
  const { authUser } = useContext(UserContext);
  const [submissions, setSubmissions] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSubmissions = async () => {
      try {
        const data = await api(`/get-beat-submissions?userId=${authUser._id}`);
        if (data?.beatBattleSubmissions) {
          setSubmissions(data.beatBattleSubmissions);
        } else {
          setSubmissions([]);
        }
      } catch (err) {
        console.error('Error fetching beat submissions:', err);
        setError('Failed to load beat battle entries.');
      }
    };

    if (authUser?._id) {
      fetchSubmissions();
    }
  }, [authUser]);

  return (
 <div className="beat-bin-container">
    <div className="beatcomp">
      <h2>Origins Beat Battle Submissions</h2>
    </div>

    {error && <p className="error">{error}</p>}

    {submissions.length === 0 ? (
      <p>No entries yet.</p>
    ) : (
      <div className="beat-entries-grid">
        {submissions.map((entry, idx) => (
          <div key={idx} className="beat-entry-card">
            <div className="beat-card-header">
              {entry.files.find(f => f.isCoverArt && f.signedUrl) && (
                <img
                  src={entry.files.find(f => f.isCoverArt).signedUrl}
                  alt="Cover Art"
                  className="cover-art-preview"
                />
              )}
              <h4 className="beat-title">{entry.projectTitle}</h4>
            </div>

            <div className="beat-card-body">
              <p><strong>Producer:</strong> {entry.producerName}</p>
              <p><strong>Email:</strong> {entry.email}</p>
              <p><strong>Location:</strong> {entry.location}</p>
              <p><strong>Social:</strong> {entry.socialContact}</p>

              <ul className="audio-list">
                {entry.files
                  .filter(file => file.type.startsWith('audio/'))
                  .map((file, i) => (
                    <li key={i}>
                        <p style={{fontWeight: 800}}>{file.fileName}</p>
                      <audio controls src={file.signedUrl}></audio>
            
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
  );
};

export default BeatBin;
